import { CellProps, formatMoney1, useWSysPage, WSysHubDisplay, WSysPage, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useKonyveloApi } from "../store/konyvelo.api";
import { Box, BoxProps, Text } from "@chakra-ui/react";
import { ReactNode } from "react";




export function BeszlaTetelek({ DOKID, tetelek }: { DOKID: number, tetelek: any[] }) {



	return <Box position='relative'>

		<Box p={2}>
			{tetelek.map((mszam, mix) => <Box key={mix}>
				<Box borderBottom='1px solid #8888' display='flex' flexDir='row' gap={3} marginTop={mix > 0 ? '1.6em' : 0}>
					<Box fontWeight='500'
						background='var(--chakra-colors-wsysLine)'
						color='#fff'
						padding='2px 1em'
						display='flex'
						alignItems='center'
						borderTopRadius='md'


					>{mszam.MSZAM}</Box>
					<Box fontWeight='500'>{mszam.TARGY}</Box>
				</Box>

				{mszam.tetelek.map((tetel: any, tix: number) => <Box key={tix}
					display='flex' flexDir='row' gap={3} justifyContent='flex-end' py={1}
				>
					<Box ml={3} mr='auto'><HivBox>{tetel.AFA_KOD}</HivBox></Box>
					<Box w='350px' textAlign='right'>{formatMoney1(tetel.ALAP, 'HUF')}</Box>
					<Box w='150px' textAlign='right'>{formatMoney1(tetel.ADO, 'HUF')}</Box>
					<Box w='150px' textAlign='right' fontWeight='500'>{formatMoney1(tetel.OSSZEG, 'HUF')}</Box>
				</Box>)}

				{mszam.hivatkozasok.map((hiv: any, hix: number) => <Box key={hix}
					display='flex' flexDir='row' gap={3} justifyContent='flex-end' py={1}
				>
					<Box ml={3}><HivBox tipus={hiv.CTIP}>{hiv.TIPUS}</HivBox></Box>
					<Box flex={1}  >
						<Text as='span' fontWeight='500'>{hiv.MSZAM}</Text>&nbsp;-&nbsp;
						<Text as='span' fontSize='small'>{hiv.TARGY}</Text>
					</Box>
				</Box>)}


			</Box>)}
		</Box>
	</Box>
}

export interface HivBoxProps extends BoxProps {
	tipus?: number;
}

export function HivBox({ tipus = 0, ...rest }: HivBoxProps) {
	let bg = 'transparent';
	switch (tipus) {
		case 40: bg = '#b4ffb4'; break; // MEG
		case 50: bg = '#ffd4f9'; break; // TIG
	}
	return <Box border='1px solid #888' fontSize='.75em' fontWeight='bold' w='50px'
		display='flex' alignItems='center' justifyContent='center' borderRadius='md'
		bg={bg}
		{...rest}
	/>
}